// ISDP CUSTOM: "Access Tokens" tab content for the internal User Settings page.
// Wraps the shared McpTokenManager with a short heading.
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { McpTokenManager } from './McpTokenManager';
import { mcpMessages } from '../../i18n/mcp';
import './McpAccessPage.css';

export const McpTokenSettingsTab = () => {
  const { t } = useTranslationRef(mcpMessages);
  return (
    <div className="devhub-mcp devhub-mcp--settings">
      <div className="devhub-mcp__settings-intro">
        <h2>{t('settings.title')}</h2>
        <p>
          {t('settings.intro1')}
          <a href="/mcp-catalog">{t('settings.catalogLink')}</a>
          {t('settings.intro2')}
        </p>
      </div>
      <McpTokenManager />
    </div>
  );
};
